const { gql } = require("graphql.macro");
const queryIdNumberRules = gql`
  query queryIdNumberRules($itemPath: String = "/sitecore/content/lynkco-global-portal/Global Setting/Id Number Rule", $language: String = "en") {
    obj: item(path: $itemPath, language: $language) {
      list: children {
        ...IdNumberRule
      }
    }
  }
  fragment IdNumberRule on IdNumberRule {
    country {
      fields: targetItem {
        key: field(name: "key") {
          value
        }
        phrase: field(name: "phrase") {
          value
        }
      }
    }
    label {
      value
    }
    pattern {
      value
    }
    birthdayPattern {
      value
    }
  }
`;
export default queryIdNumberRules;
